//import inMemoryJWT from '../auth/inMemoryJwt';
import { urlServer } from '../config/GlobalConstant'
import {
    ADD_LIKE_POST_PROFILE, IS_LOADING_LIKE_POST_PROFILE, ADD_LIKE_POST_HOME, IS_LOADING_LIKE_POST_HOME, REMOVE_LIKE_POST_HOME, ADD_LIKE_COMMENTARY, IS_LOADING_LIKE_COMMENTARY, ADD_LIKE_POST, IS_LOADING_LIKE_POST, ADD_LIKE_REPLY_COMMENTARY
} from './types'
import inMemoryJWT from '../auth/inMemoryJwt';
    
//reactions actions, actions when users react to a content

export const createReaction = (contentID, value, prevValue, isProfessional, isHome, typeLike, isSave = false) => async dispatch => {

    //  console.log()
    await fetch(`${urlServer}userreactions/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },

        body: JSON.stringify({
            contentID: contentID,
            reactionCode: value
        }
        ) // body data type must match "Content-Type" header
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            console.log();
            if (isHome) {
                dispatch({
                    type: IS_LOADING_LIKE_POST_HOME
                })
            }
            else {
                if (typeLike ==='comment') {
                    dispatch({
                        type: IS_LOADING_LIKE_COMMENTARY
                    })
                } else if (typeLike ==='post') {
                    dispatch({
                        type: IS_LOADING_LIKE_POST
                    })
                } else {
                    if (!isSave) {
                        dispatch({
                            type: IS_LOADING_LIKE_POST_PROFILE
                        })
                    } else {
                        dispatch({
                            type: "IS_LOADING_LIKE_POST_SAVE"
                        })
                    }

                }
            }
            if (typeLike ==='comment') {
                if (respJson.data.commentResponseID) {
                    dispatch({
                        type: ADD_LIKE_REPLY_COMMENTARY,
                        payload: { contentID: contentID, value: respJson.data.contentReactions }
                    })
                } else {
                    dispatch({
                        type: ADD_LIKE_COMMENTARY,
                        payload: { contentID: contentID, value: respJson.data.contentReactions }
                    })
                }

            } else if (typeLike ==='post') {
                dispatch({
                    type: ADD_LIKE_POST,
                    payload: { contentID: contentID, value: respJson.data.contentReactions }
                })
            }
            if (true || respJson.data.isEnabled) {
                var newValue = value
                if (prevValue > value)
                    newValue = value - prevValue
                if (prevValue < value)
                    newValue = value - prevValue
                console.log()
                if (isHome) {
                    dispatch({
                        type: ADD_LIKE_POST_HOME,
                        payload: { contentID: contentID, value: respJson.data.contentReactions }
                    })
                }
                else {

                    if (!isSave) {
                        dispatch({
                            type: ADD_LIKE_POST_PROFILE,
                            payload: { contentID: contentID, value: respJson.data.contentReactions }
                        })
                    } else {
                        dispatch({
                            type: "ADD_LIKE_POST_SAVE",
                            payload: { contentID: contentID, value: respJson.data.contentReactions }
                        })
                    }
                }

            }
            if (!respJson.data.isEnabled)
                if (isHome)
                    dispatch({
                        type: REMOVE_LIKE_POST_HOME,
                        payload: { contentID: contentID, value: value }
                    })
                else {
                    if (!isSave) {
                        dispatch({
                            type: ADD_LIKE_POST_PROFILE,
                            payload: { contentID: contentID, value: respJson.data.contentReactions }
                        })
                    } else {

                        dispatch({
                            type: "ADD_LIKE_POST_SAVE",
                            payload: { contentID: contentID, value: respJson.data.contentReactions }
                        })

                    }
                }
        })
        .catch(error => {
            console.log()
        })
}